import * as React from "react";
import { AddressSearchFormContainer } from "../../../../containers/modules/AddressSearchForm/containers/AddressSearchFormContainer.js";
const AddressSearchForm = (props) => /* @__PURE__ */ React.createElement(AddressSearchFormContainer, { ...props });
export {
  AddressSearchForm
};
//# sourceMappingURL=AddressSearchForm.js.map
